module.exports = __webpack_public_path__ + "img/pd-img7.a9c8ab94.png";